import { trackException } from './ApplicationInsights';
import { LoggerInterface } from './LoggerInterface';

export class AppInsightsLogger implements LoggerInterface {
  init(): void {
    return;
  }

  logError(message: string, context?: unknown): void {
    console.error(message, context);
    trackException(message, context as Record<string, unknown> | undefined);
  }

  logInfo(message: string, context?: unknown): void {
    console.log(message, context);
  }

  logWarn(message: string, context?: unknown): void {
    console.warn(message, context);
  }
}
